import React, { useState } from "react";
import QuestionnaireItem from "../QuestionnaireItem";
import BaseTextButton from "../../../../components/BaseTextButton";
import BaseDivideLine from "../../../../components/BaseDivideLine";
import { useTranslation } from "react-i18next";
import "./style.scss";

export default function QuestionnaireItems({
  text,
  questionaries,
  isBlock1,
  isBlock2,
  isBlock3,
  isBlock4,
  isBlock5,
}) {
  const { t } = useTranslation();
  const [showMoreBlock, setShowMoreBlock] = useState(false);

  return (
    <>
      <div className="questionnaire_items__questionaries-container">
        {text && (
          <div className="questionnaire_items__desc-cards-1">{text}</div>
        )}
        <div className="questionnaire_items__questionaries">
          {questionaries
            .slice(0, showMoreBlock ? questionaries.length : 4)
            .map((form, index) => {
              return (
                <QuestionnaireItem
                  isBlock1={isBlock1}
                  isBlock2={isBlock2}
                  key={index}
                  formData={form}
                  isBlock3={isBlock3}
                  isBlock4={isBlock4}
                  isBlock5={isBlock5}
                />
              );
            })}
        </div>
      </div>
      <div className="questionnaire_items__show-themes">
        {questionaries.length > 4 ? (
          <BaseTextButton onClick={() => setShowMoreBlock(!showMoreBlock)}>
            {!showMoreBlock
              ? t("insight_form_page.show_themes")
              : t("insight_form_page.show_themes_less")}
          </BaseTextButton>
        ) : null}
      </div>
      {isBlock1 || isBlock2 || isBlock3 || isBlock4 ? (
        <div className="questionnaire_items__divider">
          <BaseDivideLine dash />
        </div>
      ) : null}
    </>
  );
}
